/**
 * The traffic contacts as a HUD contact source (plan I4, `registerContactSource` in src/hud/hudModel.ts): every
 * visible local agent that is not a real ship (real ships are ECS contacts already) is a marker at its float64
 * kinematic position, coloured by its team. RR-F1 BL-2b: `labelOf` gives a promoted (real) traffic ship's purpose
 * label for the target panel. Allocation-free.
 */
import type { HudContactOut, HudContactSource } from '../hud/hudModel'
import { Agent } from './components'
import { isVisible, type ContactStore } from './contacts'

export function createHudContactSource(s: ContactStore): HudContactSource {
  return {
    count: () => s.count,
    read(i: number, out: HudContactOut): boolean {
      if (i >= s.count || s.eid[i] >= 0 || !isVisible(s, i)) return false
      out.x = s.x[i]
      out.y = s.y[i]
      out.z = s.z[i]
      out.team = s.team[i]
      out.hull = s.hp[i]
      return true
    },
    labelOf(eid: number): string {
      if (eid < 0) return ''
      const slot = Agent.index[eid]
      return slot >= 0 && slot < s.count && s.eid[slot] === eid ? s.label[slot] : ''
    },
  }
}
